import { render, staticRenderFns } from "./istilahsaik.vue?vue&type=template&id=a3552618"
import script from "./istilahsaik.vue?vue&type=script&lang=js"
export * from "./istilahsaik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports